import { JsonApiDecorator } from '../json-api/JsonApiDecorator';
import { camelCase, upperFirst } from 'lodash';

export const buildGenericProps = (state, type, include, metaEntities = []) => {
  const apiStore = new JsonApiDecorator(state.api);
  let props;
  const collection = apiStore[type]?.all(include) || [];
  const collectionMeta = state.api[type]?.meta;
  props = {
    collection,
    [type]: collection,
    collectionMeta,
    [`${type}Meta`]: collectionMeta,
  };
  metaEntities?.forEach(entity => (props[`${entity}Meta`] = state.api[entity]?.meta));
  props.showAlertMessage = true;
  if (state.api.currentEntityId && state.api.currentEntityId !== 'add') {
    props.currentEntity = apiStore[type]?.find(state.api.currentEntityId, include);
    props.showAlertMessage = false;
  }
  const { activePage, activeFilters, activeSort, activeSearch, activeState } = state.api;
  props = { ...props, activePage, activeFilters, activeSort, activeSearch, activeState };
  if (state.api.currentEntityId === 'add') {
    props.currentEntity = apiStore.newObject(type);
    props.showAlertMessage = false;
  }
  if (!props.currentEntity && state.api.currentEntity) {
    props.currentEntity = state.api.currentEntity;
  }
  const { loadingEntities } = state.api;
  if (loadingEntities) {
    Object.keys(loadingEntities).forEach(key => {
      props[`isLoading${upperFirst(camelCase(loadingEntities[key]))}`] = true;
    });
    props.isLoadingData = Object.values(loadingEntities).includes(type);
  }
  props.errorMessage = state.api.errorMessage;
  props.errorMessages = state.api.errorMessages;
  props.successMessage = state.api.successMessage;
  props.downloadProcessing = state.api.downloadProcessing;
  props.downloadUrl = state.api.downloadUrl;
  props.downloadTimedOut = state.api.downloadTimedOut;
  return props;
};
